import httpsV2 from '../../httpsV2'

export const getSuppliers = (limit, offset) => {
  return httpsV2.get(`/middleware/suppliers?limit=${limit}&offset=${offset}`)
}

export const getAllSuppliers = () => {
  return httpsV2.get(`/middleware/suppliers`)
}

export const getAllSuppliersWithContacts = () => {
  return httpsV2.get(`/middleware/suppliers?contacts=true`)
}

export const getSupplier = (id) => {
  return httpsV2.get(`/middleware/supplier/${id}`)
}

export const updateSupplier = (id, data) => {
  return httpsV2.put(`/middleware/supplier/${id}`, data)
}

export const createSupplier = (data) => {
  return httpsV2.post('/middleware/supplier', data)
}

export const activateSupplier = (id) => {
  return httpsV2.put(`/middleware/supplier/${id}/activate`)
}

export const deactivateSupplier = (id) => {
  return httpsV2.delete(`/middleware/supplier/${id}`)
}

export const createSuppliers = (data) => {
  return httpsV2.post('/middleware/suppliers', data)
}
